import { connect } from 'react-redux';

import { getOfficesShortList } from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  addTaskLocation,
  createTask,
  getTaskDetails,
  getTaskLocation,
  getTaskType,
} from '../tasksActions';
// Component
import CreateNotCompletedTask from './CreateNotCompletedTask';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  isLoading: state.task.isLoading,
  officesShortList: state.office.officesShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  createdTaskInfo: state.task.createdTaskInfo,
  callback: state.task.callback,
  taskDetails: state.task.taskDetails,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getTaskDetails: params => dispatch(getTaskDetails(params)),
  createTask: params => dispatch(createTask(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTaskType: params => dispatch(getTaskType(params)),
});

// connect states and dispatchers with components
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateNotCompletedTask);
